import { render, staticRenderFns } from "./ExpandableOrderUser.vue?vue&type=template&id=17ddcb08&scoped=true&"
import script from "./ExpandableOrderUser.vue?vue&type=script&lang=js&"
export * from "./ExpandableOrderUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ddcb08",
  null
  
)

export default component.exports